import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PriorityFilterPipe } from "./priority-filter.pipe";
import { SearchFilterPipe } from "./search-filter.pipe";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PriorityFilterPipe,
    SearchFilterPipe
  ],
  exports: [
    PriorityFilterPipe,
    SearchFilterPipe
  ]
})
export class PipesModule { }
